import { render, staticRenderFns } from "./RelativeProfileEdit.vue?vue&type=template&id=a1873528&scoped=true&"
import script from "./RelativeProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./RelativeProfileEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1873528",
  null
  
)

export default component.exports